var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 479,
    height: 479,
    viewBox: "0 0 479 479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#ccc;}.c{fill:#e6e6e6;}.d{fill:#3f3d56;}.e,.k{fill:#2f2e41;}.f{fill:#e25353;}.g{fill:#b54242;}.h{opacity:0.2;}.i{fill:#f2f2f2;}.j{opacity:0.39;}.k{mix-blend-mode:multiply;isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1194 -1823)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22680 24862)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 479,
    height: 479,
    transform: "translate(-21486 -23039)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21462.32 -22936)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M611.044,701.689H243.337a12.329,12.329,0,0,1-12.329-12.329h0q199.94-23.237,392.365,0h0A12.329,12.329,0,0,1,611.044,701.689Z",
    transform: "translate(-197.538 -428.267)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M623.371,435.711l-392.363-.725,45.474-76.515.218-.363V189.478a15.585,15.585,0,0,1,15.587-15.586H559.921a15.585,15.585,0,0,1,15.586,15.587V359.268Z",
    transform: "translate(-197.538 -173.893)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M348.872,195.864a5.082,5.082,0,0,0-5.077,5.077V354.7a5.083,5.083,0,0,0,5.077,5.077H619.393a5.083,5.083,0,0,0,5.077-5.077V200.941a5.083,5.083,0,0,0-5.077-5.077Z",
    transform: "translate(-254.48 -184.985)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M341.133,567.913a2.182,2.182,0,0,0-1.977,1.266L325.145,599.64a2.176,2.176,0,0,0,1.976,3.085H621.783a2.175,2.175,0,0,0,1.946-3.149L608.5,569.116a2.165,2.165,0,0,0-1.946-1.2Z",
    transform: "translate(-244.964 -372.819)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.264,
    cy: 3.264,
    r: 3.264,
    transform: "translate(225.301 1.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M560.732,649.94a2.179,2.179,0,0,0-2.1,1.61L555.116,664.6a2.176,2.176,0,0,0,2.1,2.742H624.06a2.175,2.175,0,0,0,2.055-2.888L621.6,651.4a2.177,2.177,0,0,0-2.056-1.464Z",
    transform: "translate(-361.13 -414.231)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M461.193,366.922v2.9H162.169l.225-.363v-2.539Z",
    transform: "translate(-83.225 -185.245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M850.814,554.237a.531.531,0,0,0-.512.392l-.856,3.179a.53.53,0,0,0,.512.668h16.277a.53.53,0,0,0,.5-.7l-1.1-3.179a.53.53,0,0,0-.5-.356Z",
    transform: "translate(-509.755 -365.914)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M802.814,554.237a.531.531,0,0,0-.512.392l-.856,3.179a.53.53,0,0,0,.512.668h16.277a.53.53,0,0,0,.5-.7l-1.1-3.179a.53.53,0,0,0-.5-.356Z",
    transform: "translate(-485.522 -365.914)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M629.607,421.164h1.276l-2.551-170.52h-1.276l.051,3.4H598.514l.051-3.4h-1.276l-2.551,170.52h1.276l.165-11.056h33.263ZM627.768,298.27H597.852l.312-20.837h29.293Zm.019,1.276.312,20.837H597.521l.312-20.837Zm.331,22.112.312,20.837H597.19l.312-20.837Zm.331,22.112.312,20.837h-31.9l.312-20.837Zm.331,22.112.312,20.837H596.529l.312-20.837Zm-1.654-110.561.312,20.837H598.183l.312-20.837ZM596.2,408.832,596.51,388h32.6l.312,20.837Z",
    transform: "translate(-381.171 -212.642)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 20.802,
    cy: 20.802,
    r: 20.802,
    transform: "translate(204.517 55.131)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 6.32,
    height: 11.323,
    transform: "translate(231.337 91.436) rotate(-10.261)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 6.32,
    height: 11.323,
    transform: "translate(218.9 93.688) rotate(-10.261)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 5.266,
    cy: 1.975,
    rx: 5.266,
    ry: 1.975,
    transform: "matrix(0.763, -0.646, 0.646, 0.763, 217.646, 107.562)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 5.266,
    cy: 1.975,
    rx: 5.266,
    ry: 1.975,
    transform: "matrix(0.763, -0.646, 0.646, 0.763, 229.825, 105.358)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 7.109,
    cy: 7.109,
    r: 7.109,
    transform: "translate(216.753 63.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 2.37,
    cy: 2.37,
    r: 2.37,
    transform: "translate(218.571 65.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M620.217,266.675c.313-7.7-6.324-14.224-14.825-14.569s-15.645,5.618-15.958,13.319,5.6,9.451,14.1,9.8S619.9,274.376,620.217,266.675Z",
    transform: "translate(-378.488 -213.372)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 3.265,
    cy: 10.401,
    rx: 3.265,
    ry: 10.401,
    transform: "matrix(0.223, -0.975, 0.975, 0.223, 195.243, 73.002)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 3.265,
    cy: 10.401,
    rx: 3.265,
    ry: 10.401,
    transform: "matrix(0.223, -0.975, 0.975, 0.223, 236.076, 79.793)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M620.433,341.287a4.74,4.74,0,0,1-9.326,1.7l0-.009c-.466-2.576,1.525-3.487,4.1-3.954S619.966,338.712,620.433,341.287Z",
    transform: "translate(-389.4 -257.156)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 10.662,
    cy: 3.347,
    rx: 10.662,
    ry: 3.347,
    transform: "matrix(0.357, -0.934, 0.934, 0.357, 144.803, 154.154)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 21.324,
    cy: 21.324,
    r: 21.324,
    transform: "translate(107.563 179.124) rotate(-80.783)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 6.478,
    height: 11.607,
    transform: "translate(122.31 178.227)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 6.478,
    height: 11.607,
    transform: "translate(135.267 178.227)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 5.399,
    cy: 2.024,
    rx: 5.399,
    ry: 2.024,
    transform: "translate(122.31 187.945)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 5.399,
    cy: 2.024,
    rx: 5.399,
    ry: 2.024,
    transform: "translate(135.267 187.675)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M387.961,441.822c-1.722-7.711,3.782-15.5,12.294-17.4s16.807,2.81,18.529,10.521-3.919,10.555-12.43,12.456S389.682,449.534,387.961,441.822Z",
    transform: "translate(-276.618 -300.161)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 3.347,
    cy: 10.662,
    rx: 3.347,
    ry: 10.662,
    transform: "translate(96.942 150.053) rotate(-64.626)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 21.324,
    cy: 21.324,
    r: 21.324,
    transform: "translate(18.371 161.759)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 6.478,
    height: 11.607,
    transform: "translate(29.977 199.819)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 6.478,
    height: 11.607,
    transform: "translate(42.934 199.819)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 5.399,
    cy: 2.024,
    rx: 5.399,
    ry: 2.024,
    transform: "translate(29.977 209.537)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 5.399,
    cy: 2.024,
    rx: 5.399,
    ry: 2.024,
    transform: "translate(42.934 209.267)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 7.288,
    cy: 7.288,
    r: 7.288,
    transform: "translate(32.947 170.397)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 2.429,
    cy: 2.429,
    r: 2.429,
    transform: "translate(37.805 175.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M201.483,485.429c-1.722-7.711,3.782-15.5,12.294-17.4s16.807,2.81,18.529,10.521S228.386,489.1,219.875,491,203.2,493.141,201.483,485.429Z",
    transform: "translate(-182.473 -322.177)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 10.662,
    cy: 3.347,
    rx: 10.662,
    ry: 3.347,
    transform: "matrix(0.357, -0.934, 0.934, 0.357, 45.183, 114.472)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 21.324,
    cy: 21.324,
    r: 21.324,
    transform: "translate(7.942 139.443) rotate(-80.783)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 6.478,
    height: 11.607,
    transform: "translate(22.689 138.545)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 6.478,
    height: 11.607,
    transform: "translate(35.646 138.545)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 5.399,
    cy: 2.024,
    rx: 5.399,
    ry: 2.024,
    transform: "translate(22.689 148.263)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 5.399,
    cy: 2.024,
    rx: 5.399,
    ry: 2.024,
    transform: "translate(35.646 147.993)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 7.288,
    cy: 7.288,
    r: 7.288,
    transform: "translate(25.659 109.124)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 2.429,
    cy: 2.429,
    r: 2.429,
    transform: "translate(30.517 113.982)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M186.764,361.679c-1.722-7.711,3.782-15.5,12.294-17.4s16.807,2.81,18.529,10.521-3.919,10.555-12.43,12.456S188.485,369.391,186.764,361.679Z",
    transform: "translate(-175.042 -259.7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 3.347,
    cy: 10.662,
    rx: 3.347,
    ry: 10.662,
    transform: "translate(-2.679 110.371) rotate(-64.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M207.707,432.8c0,2.087,5.374,6.208,11.337,6.208s11.554-5.876,11.554-7.963-5.591.4-11.554.4S207.707,430.717,207.707,432.8Z",
    transform: "translate(-185.775 -303.301)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M269.689,255.461a1.487,1.487,0,0,0-1.485,1.485v61.4a1.487,1.487,0,0,0,1.485,1.485h142.1a1.487,1.487,0,0,0,1.485-1.485v-61.4a1.487,1.487,0,0,0-1.485-1.485Z",
    transform: "translate(-216.317 -215.074)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 14.419,
    cy: 14.419,
    r: 14.419,
    transform: "translate(77.323 58.153)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M412.7,316.587a1.686,1.686,0,1,0,0,3.372H458.23a1.686,1.686,0,0,0,.055-3.372H412.7Z",
    transform: "translate(-288.418 -245.933)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M412.7,296.86a1.686,1.686,0,1,0,0,3.372h22.735a1.686,1.686,0,1,0,.055-3.372H412.7Z",
    transform: "translate(-288.418 -235.974)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M412.7,337.253a1.686,1.686,0,1,0,0,3.372H458.23a1.686,1.686,0,1,0,.055-3.372H412.7Z",
    transform: "translate(-288.418 -256.367)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 3.347,
    cy: 10.662,
    rx: 3.347,
    ry: 10.662,
    transform: "matrix(0.934, -0.357, 0.357, 0.934, 334.647, 175.728)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 21.324,
    cy: 21.324,
    r: 21.324,
    transform: "translate(332.371 187.421) rotate(-9.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M736.43,447.932h-6.478l1.268,13.9,5.222-1.419Z",
    transform: "translate(-369.877 -226.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M707.906,448.005h-6.478l1.268,13.9,4.986-1.455Z",
    transform: "translate(-355.477 -226.181)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 5.399,
    cy: 2.024,
    rx: 5.399,
    ry: 2.024,
    transform: "translate(341.357 232.733) rotate(-4.182)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 7.288,
    cy: 7.288,
    r: 7.288,
    transform: "translate(349.008 192.366)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 2.429,
    cy: 2.429,
    r: 2.429,
    transform: "translate(353.866 197.225)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 10.662,
    cy: 3.347,
    rx: 10.662,
    ry: 3.347,
    transform: "translate(370.339 196.796) rotate(-53.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M863.077,605.014c0-1.72,4.429-5.117,9.344-5.117s9.523,4.843,9.523,6.563-4.608-.334-9.523-.334S863.077,606.734,863.077,605.014Z",
    transform: "translate(-516.646 -388.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M882.791,432.385,766.062,416.2a3.47,3.47,0,0,1-2.957-3.909l13.122-94.657a3.47,3.47,0,0,1,3.909-2.957l116.727,16.182a3.47,3.47,0,0,1,2.957,3.909L886.7,429.428a3.47,3.47,0,0,1-3.907,2.957Z",
    transform: "translate(-466.157 -244.955)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M859.415,437.707l-59.592-8.261a1.225,1.225,0,0,1-.22-.049l34.952-44.912a1.992,1.992,0,0,1,3.435.476l14.374,35.384.689,1.693Z",
    transform: "translate(-484.6 -279.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M738.976,301.177l-20.346-2.82,12-13.123.864-.945.432-.473.689,1.693Z",
    transform: "translate(-364.161 -143.287)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M934.86,462.247,883.318,455.1l12-13.123.864-.945,15.636-17.1a2.659,2.659,0,0,1,3.942.308,2.372,2.372,0,0,1,.155.26Z",
    transform: "translate(-526.865 -299.758)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8.912,
    cy: 8.912,
    r: 8.912,
    transform: "translate(366.627 102.089)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 10.893,
    height: 10.893,
    transform: "translate(315.97 77.003) rotate(7.893)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M894.123,529.8c1.722-7.711-3.782-15.5-12.294-17.4s-16.807,2.81-18.529,10.521,3.919,10.555,12.43,12.456S892.4,537.51,894.123,529.8Z",
    transform: "translate(-516.602 -344.577)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 5.399,
    cy: 2.024,
    rx: 5.399,
    ry: 2.024,
    transform: "translate(355.563 232.699) rotate(-4.182)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "translate(-21538.02 -23002.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 71.287,
    cy: 71.287,
    r: 71.287,
    transform: "translate(220.02 131.75)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M775.99,397.506v60.651a1.562,1.562,0,0,0,2.339,1.439l48.077-30.326a1.718,1.718,0,0,0,0-2.859l-48.077-30.326a1.547,1.547,0,0,0-2.339,1.419Z",
    transform: "translate(-22047.988 -23226.867)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadButton);
export default __webpack_public_path__ + "static/media/download-button.00e0bf31e2d1d4e714fedecaea1ae047.svg";
export { ForwardRef as ReactComponent };